import { generateClient } from 'aws-amplify/data';
import type { Schema } from '../../amplify/data/resource';

export type ApiSchema = Schema;
export const ApiClient = generateClient<Schema>({
    authMode: "userPool",
});

export type Nullable<T> = {
    [K in keyof T]: T[K] | null;
};

export type Undefinedable<T> = {
    [K in keyof T]: T[K] | undefined;
};

export type FetchResponse<T> = {
    items: T[],
    nextToken?: string | null | undefined;
};

export type SingularReturnValue<T> = {
    data: T | null;
    errors?: { message: string }[];
    extensions?: Record<string, unknown>;
};

export type ApiErrorType = {

}
export class ApiError extends Error {
    code: string;
    metadata?: Record<string, any>;

    constructor(message: string, code: string, metadata?: Record<string, any>) {
        super(message);
        this.name = 'ApiError';
        this.code = code;
        this.metadata = metadata;

        if (Error.captureStackTrace) {
            Error.captureStackTrace(this, ApiError);
        }
    }
}

export class NotFoundError extends Error {
    code: string;
    metadata?: Record<string, any>;

    constructor(message: string, code: string, metadata?: Record<string, any>) {
        super(message);
        this.name = 'ApiError';
        this.code = code;
        this.metadata = metadata;

        if (Error.captureStackTrace) {
            Error.captureStackTrace(this, ApiError);
        }
    }
}

export class TenantPausedError extends Error {
    code: string;
    metadata?: Record<string, any>;

    constructor(message: string, code: string, metadata?: Record<string, any>) {
        super(message);
        this.name = 'TenantPausedError';
        this.code = code;
        this.metadata = metadata;

        if (Error.captureStackTrace) {
            Error.captureStackTrace(this, TenantPausedError);
        }
    }
}